// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"623":"ad7a217b","787":"50c9ebb0"}[chunkId] + ".chunk.js";
};